import {
  CURRENT_FORMAT_VERSION,
  type Course,
  type Project,
  type ProjectFile,
} from '@rcs/data-schema';
import { PHYSICS_ENGINE_VERSION } from '@rcs/physics';

/** アプリの版（保存データの `applicationVersion`）。 */
export const APPLICATION_VERSION = '0.1.0';

/** プロジェクトを、保存・書き出し用のファイル（版情報つき）にする。 */
export function toProjectFile(project: Project): ProjectFile {
  return {
    kind: 'rcs.project',
    formatVersion: CURRENT_FORMAT_VERSION,
    applicationVersion: APPLICATION_VERSION,
    physicsEngineVersion: PHYSICS_ENGINE_VERSION,
    project,
  };
}

/**
 * 編集したコースをプロジェクトへ反映する。同じ ID のコースを置き換え、なければ先頭のコースを置き換える。
 *
 * @param now 更新日時（ISO 8601）
 */
export function withCourse(project: Project, course: Course, now: string): Project {
  const matched = project.courses.some((c) => c.id === course.id);
  const courses = project.courses.map((c, index) =>
    (matched ? c.id === course.id : index === 0) ? { ...course, updatedAt: now } : c,
  );
  return { ...project, courses: courses.length > 0 ? courses : [course], updatedAt: now };
}
